<template>
  <div class="message-form-container">
    <div class="message-form">
      <h3 class="form-title">留言</h3>
      <p class="form-description">
        如果您对我们的产品感兴趣，想了解更多详情，请在这里留言，我们会尽快回复您。
      </p>

      <el-form ref="messageForm" :model="formData" :rules="rules" label-width="0" @submit.native.prevent>
        <el-form-item prop="email">
          <el-input
            v-model="formData.email"
            type="email"
            placeholder="请输入您的邮箱地址"
            clearable
          />
        </el-form-item>

        <el-form-item prop="phone">
          <el-input
            v-model="formData.phone"
            type="text"
            placeholder="请输入您的电话或WhatsApp"
            clearable
          />
        </el-form-item>

        <el-form-item prop="message">
          <el-input
            v-model="formData.message"
            type="textarea"
            :rows="5"
            placeholder="请详细描述您想了解的产品信息..."
            clearable
          />
        </el-form-item>

        <el-form-item>
          <el-button type="danger" class="submit-btn" :loading="isSubmitting" @click="handleValidateAndSubmit">
            {{ isSubmitting ? '提交中...' : '提交' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageForm',
  props: {
    productTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        email: '',
        phone: '',
        message: ''
      },
      isSubmitting: false,
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入电话或WhatsApp', trigger: 'blur' },
          { pattern: /^\+?[0-9\-\s]{6,20}$/, message: '请输入有效的电话/WhatsApp', trigger: ['blur', 'change'] }
        ],
        message: [
          { required: true, message: '请输入产品详细信息', trigger: 'blur' },
          { min: 5, message: '详细信息不少于5个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleValidateAndSubmit() {
      this.$refs.messageForm?.validate((valid) => {
        if (valid) {
          this.submitForm()
        }
      })
    },
    async submitForm() {
      this.isSubmitting = true

      try {
        // 预留提交接口位置
        const submitData = {
          ...this.formData,
          productTitle: this.productTitle,
          submitTime: new Date().toISOString()
        }

        // TODO: 这里添加实际的API调用
        console.log('提交数据:', submitData)

        // 模拟API调用
        await new Promise(resolve => setTimeout(resolve, 1000))

        // 提交成功提示
        this.$message?.success('留言提交成功，我们会尽快回复您！')

        // 重置表单
        this.resetForm()
        this.$nextTick(() => this.$refs.messageForm?.clearValidate())

      } catch (error) {
        console.error('提交失败:', error)
        this.$message?.error('提交失败，请稍后重试')
      } finally {
        this.isSubmitting = false
      }
    },

    resetForm() {
      this.formData = {
        email: '',
        phone: '',
        message: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-form-container {
  width: 100%;
  background: #f8f9fa;
  padding: 40px 0;
  margin-top: 40px;
}

.message-form {
  margin: 0 auto;
  padding: 0 40px;

  .form-title {
    width: 120px;
    height: 34px;
    font-size: 24px;
    margin-bottom: 20px;
    color: black;
    font-weight: 500;
  }

  .form-description {
    font-size: 16px;
    color: #666;
    line-height: 1;
    margin-bottom: 60px;
  }

  form {
    .form-group {
      margin-bottom: 20px;

      input, textarea {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        transition: border-color 0.3s ease;

        &:focus {
          outline: none;
          border-color: #0555b6;
          box-shadow: 0 0 0 2px rgba(5, 85, 182, 0.1);
        }

        &::placeholder {
          color: #999;
        }
      }

      textarea {
        resize: vertical;
        min-height: 120px;
      }
    }

    .submit-btn {
      background-color: #e74c3c;
      color: white;
      padding: 12px 32px;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        background-color: #c0392b;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
      }

      &:disabled {
        background-color: #bdc3c7;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .message-form-container {
    padding: 20px 0;
  }

  .message-form {
    padding: 0 15px;

    .form-title {
      font-size: 16px;
      width: 100px;
      height: 30px;
    }

    .form-description {
      font-size: 14px;
    }

    form {
      .form-group {
        margin-bottom: 16px;

        input, textarea {
          padding: 10px 12px;
          font-size: 14px;
        }
      }

      .submit-btn {
        width: 100%;
        padding: 12px;
        font-size: 15px;
      }
    }
  }
}
</style>
